import { ChevronDown, ChevronUp } from 'lucide-react'
import { useState } from 'react'

import { Table } from 'slab'

import { type EmployeeTableRow } from '../types'

export default function SelectedEmployeesList ({
  employees,
}: {
  employees: EmployeeTableRow[]
}) {
  const [isOpen, setIsOpen] = useState(false)

  const firstFiveEmployees = employees.slice(0, 5)
  const remainingEmployees = employees.slice(5)

  const TableRows = ({ list }: { list: EmployeeTableRow[] }) => (
    <>
      {list.map((employee) => {
        return (
          <Table.Row key={employee.id}>
            <Table.RowHeader>
              <span className='font-light'>{employee.first_name} {employee.last_name}</span>
            </Table.RowHeader>
          </Table.Row>
        )
      })}
    </>
  )

  return (
    <div>
      <div className='font-semibold mb-2'>
        Selected employees{' '}
        <span className='italic font-light'>({employees.length} selected)</span>
      </div>
      <Table width='full'>
        <Table.Body>
          <TableRows list={firstFiveEmployees} />
          {remainingEmployees.length > 0 && isOpen && (
            <TableRows list={remainingEmployees} />
          )}
        </Table.Body>
      </Table>
      {remainingEmployees.length > 0 && !isOpen && (
        <div
          className='text-thatch-purple-primary cursor-pointer mt-4 mb-4'
          onClick={() => {
            setIsOpen(!isOpen)
            window.segment?.track('[ER] Selected employees list expanded', {
              selected_employees_count: employees.length,
            })
          }}
        >
          <div className='flex items-center'>
            <ChevronDown size={16} />
            <span className='pl-1'>
              Show {remainingEmployees.length} more
            </span>
          </div>
        </div>
      )}
      {remainingEmployees.length > 0 && isOpen && (
        <div
          className='text-thatch-purple-primary cursor-pointer mt-4 mb-4'
          onClick={() => {
            setIsOpen(!isOpen)
            window.segment?.track('[ER] Selected employees list collapsed', {
              selected_employees_count: employees.length,
            })
          }}
        >
          <div className='flex items-center'>
            <ChevronUp size={16} />
            <span className='pl-1'>Hide</span>
          </div>
        </div>
      )}
    </div>
  )
}
